// External
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

// Internal
import { UsefulService } from '../../services/global/useful/useful.service';
import { ValuesService } from '../../values/values.service';

@Injectable({ providedIn: 'root' })

export class RedirectGuard {

    constructor(
        private readonly usefulService: UsefulService,
        private readonly router: Router,
        private readonly valuesService: ValuesService
    ) { }

    // guard to activate a route
    // asta se ruleaza doar cand nu am /:id in path sau cand calea incepe cu parental si nu se face match cu vreun copil din organiser.routes
    // daca am profile_id, il transform in hash si se reia logica din parental.organiser.routes (adica se incearca sa se faca match din nou)
    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean|UrlTree>|Promise<boolean|UrlTree>|boolean|UrlTree {
        const fakeChildCrc = this.usefulService.getNested(route, "", "params", "child");
        const childId = this.usefulService.getNested(route, "", "queryParams", "child_id");
        const profileId = this.usefulService.getNested(route, "", "queryParams", "profile_id");
        let childCrc = null;

        if (profileId) {
            childCrc = this.usefulService.crc32Convert(profileId);
        }

        if (childId) {
            childCrc = this.usefulService.crc32Convert(childId);
        }
        if (childCrc) {
            if (this.valuesService.centralPaths.parental[fakeChildCrc]) {
               this.router.navigate([(`/${this.valuesService.centralPaths.parental.id}/${childCrc}/${fakeChildCrc}`)], { replaceUrl: true });
            } else {
               this.router.navigate([(`/${this.valuesService.centralPaths.parental.id}/${childCrc}`)], { replaceUrl: true });
            }
            return false;
        }
        return true;

    }
}